import {
  TKwikUIInputCurrencyType,
  TKwikUIInputCurrencySize,
  VKwikUIInputCurrencyType,
  VKwikUIInputCurrencySize
} from "./input-currency.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";
  const isStringOrNumber = (x: string | number) =>
    typeof x === "number" || typeof x === "string";

  const methods = {
    currencyType: (x: TKwikUIInputCurrencyType) =>
      VKwikUIInputCurrencyType.includes(x),
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputCurrencySize) => VKwikUIInputCurrencySize.includes(x),
    value: isStringOrNumber
  };

  return methods[key] && methods[key](value);
};
